export const lowercaseRegex = '[a-z]';
export const uppercaseRegex = '[A-Z]';
export const numberRegex = '[0-9]';
export const specialCharRegex = '[!@#$%^&*=(),./?":{}|<>+_§-]';

export const passwordRegex = new RegExp(
  `^(?=.*${lowercaseRegex})(?=.*${uppercaseRegex})(?=.*${numberRegex})(?=.*${specialCharRegex})(?=.{8,})`,
);
